import { HStack, Icon, Text } from "@chakra-ui/react";
import type { TFunction } from "i18next";
import { FaHistory } from "react-icons/fa";
import { useTranslation } from "react-i18next";
import { PreviousSigningOutcome } from "../../../../autogen/bff-api";

interface Props {
  outcome: PreviousSigningOutcome;
}

const labelFor = (outcome: PreviousSigningOutcome, t: TFunction): string => {
  switch (outcome) {
    case PreviousSigningOutcome.Canceled:
      return t("A previous signing attempt was cancelled.");
    case PreviousSigningOutcome.Expired:
      return t("A previous signing attempt expired.");
    case PreviousSigningOutcome.Failed:
      return t("A previous signing attempt failed.");
  }
};

export const PreviousSigningBreadcrumb = ({ outcome }: Props) => {
  const { t } = useTranslation();
  const label = labelFor(outcome, t);
  return (
    <HStack
      spacing="2"
      bg="smChipBlueBg"
      color="smChipBlueFg"
      px="3"
      py="1"
      borderRadius="full"
      display="inline-flex"
      width="fit-content"
      data-testid="previous-signing-breadcrumb"
    >
      <Icon as={FaHistory} boxSize="3" />
      <Text fontSize="sm" fontWeight="medium">
        {label}
      </Text>
    </HStack>
  );
};
